// extracted by mini-css-extract-plugin
module.exports = {"copyItem":"styles_copyItem__1b-cY"};